
import { useEffect } from 'react'
import Select from 'react-select'
import { EnergyStatusDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPEnergyStatusDDL = (props) => {
    const { EnergyStatus, setEnergyStatus, rowData, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            Flag: Flag,
        }
        dispatch(EnergyStatusDDLAPI({ data }))
    }, [])

    const { EnergyStatusData } = useSelector(state => state.EnergyStatusDDL)

    useEffect(() => {
        handleSTPEnergyStatusDDL()
    }, [EnergyStatusData])

    const handleSTPEnergyStatusDDL = () => {
        // console.log(DeptDDLDataa)
        if (EnergyStatusData && EnergyStatusData.table && EnergyStatusData.table.length > 0) {
            let list = EnergyStatusData.table.map((item, index) => ({
                value: item.m_IndicatorID,
                label: item.indicatorName,
            }))
            setEnergyStatus({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_IndicatorSTPEnergyID : list[0].value,
                Label: Flag === 'Update' ? rowData.indicatorSTPEnergyName : list[0].label,
            })
        }
        else {
            setEnergyStatus({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Energy Status</b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: EnergyStatus.ID, label: EnergyStatus.Label }}
                onChange={(e) => {
                    e ?
                        setEnergyStatus({ ...EnergyStatus, ID: e.value, Label: e.label })
                        :
                        setEnergyStatus({ ...EnergyStatus, ID: 0, Label: "Select..." })

                }}
                options={EnergyStatus.DDL}
            />
        </div>
    )
}